import { useSchema } from './useSchema';
import { SchemaHolder } from './schema';
import { Context, useContext } from './context';
import { QueryParameters, QueryParametersValue, QueryParametersKey, ChangeSource } from './types';

export function useFilterField<
  StaticProps,
  SearchQuery,
  Parameters extends QueryParameters,
  FilterKey extends QueryParametersKey<Parameters>,
>(props: {
  staticProps: StaticProps;
  defaultParameters: Parameters;
  schemaHolder: SchemaHolder<StaticProps, SearchQuery, Parameters>;
  context: Context<Parameters>;
  source: ChangeSource;
  filterKey: FilterKey;
}) {
  const schema = useSchema<StaticProps, SearchQuery, Parameters>({
    context: props.context,
    schemaHolder: props.schemaHolder,
    defaultParameters: props.defaultParameters,
    staticProps: props.staticProps,
  });
  const { setParameters } = useContext<Parameters>(props.context);

  const defaultValue = schema.getDefaultValue(props.filterKey);
  const value = schema.getValue(props.filterKey);

  const setValue = (newValue: QueryParametersValue<Parameters, FilterKey>) => {
    const changes = { [props.filterKey]: newValue } as unknown as Partial<Parameters>; // TODO: type safety
    setParameters(props.source, changes);
  };

  return { setValue, value, defaultValue, staticProps: props.staticProps };
}
